import {SELECT_VIEW} from '../components/page/settings/constants';
import {selectViewFunction} from '../moduls/utils';

const getStepStructure = function (step) {
  const StepStructure = selectViewFunction(step, SELECT_VIEW);
  return StepStructure.backDataToModel(step);
}

export default class Widget {
  constructor(data) {
    this.id = ('id' in data) ? data.id : 0;
    this.type = ('type' in data) ? data.type : 'poll';
    this.title = ('title' in data) ? data.title : null;
    this.description = ('description' in data) ? data.description : null;
    this.question = ('question' in data) ? data.question : null;
    this.steps = ('steps' in data) ? new Map(Object.entries(data.steps).map((item) => [item[0], getStepStructure(item[1])])) : {};
    this._start = ('start' in data) ? data.start : null;
  }

  get start() {
    return this._start;
  }
};

/**
 * WIDGET:
 * {
 *   title, ?description, type = poll | test | contest,
 *   start: `#id`,
 *   questions: { `#id`: QUESTION, ... },
 * }
 * QUESTION:
 * {
 *   type: `sipmle-question`,
 *   title, is_multiple, ?score, ?min_limit, ?max_limit,
 *   answers: [ ANSWER, ... ],
 *   ?media = image | video,
 *   ?comment_title, ?comment_image,
 * }
 * ANSWER:
 * {
 *   title, ?description, ?is_correct, ?score,
 *   ?media = image | video,
 *   ?comment_title, ?comment_image, ?exeption,
 *   nextQuestion: `#id` | null
 * }
 */



// WEBPACK FOOTER //
// ./model/widget.js